import axiosClient from "utils/api/axios-client";

const restaurantIdentityApi = {
  getAll: (params) => {
    const url = "/api/v1/restaurant-identities";
    return axiosClient.get(url, { params });
  },
  getById: (id) => {
    const url = `/api/v1/restaurant-identities/${id}`;
    return axiosClient.get(url);
  },
  verify: (id) => {
    const url = `/api/v1/restaurant-identities/${id}/verify`;
    return axiosClient.put(url);
  },
  reject: (id, reason) => {
    const url = `/api/v1/restaurant-identities/${id}/reject`;
    return axiosClient.put(url, { reason });
  },
  delete: (id) => {
    const url = `/api/v1/restaurant-identities/${id}`;
    return axiosClient.delete(url);
  },
};

export default restaurantIdentityApi;
